export const steps = [
  {
    id: 1,
    title: "Video Lectures",
    image:"../assets/global/recorded_sessions.jpg",
    text: "Covers Entire Pharmacology Syllabus. Designed for RRB & All State Pharmacist exams.",
    features: [
      { icon: 'icon-graduation-1', text: 'Complete coaching for competitive exams' },
      { icon: 'icon-wall-clock', text: 'Watch Recorded Classes – Learn at Your Pace' },
      { icon: 'icon-location', text: 'Your Learning, Anytime. Anywhere.' }
    ]
  },
  {
    id: 4,
    image:"../assets/global/CARD-2.jpg",
    title: "MCQs for the practice",
    text: "Click to access 3000 MCQs for practice at just @99/-",
    features: [
      { icon: 'icon-puzzle', text: 'Test Your Knowledge' },
      { icon: 'icon-bar-chart', text: 'Topic wise MCQs and mock tests' },
      { icon: 'icon-infinity', text: 'Pay Once and Access Forever' }
    ]
  },
  {
    id: 5,
    image:"../assets/global/CARD-3.jpg",
    title: "Free Downloads",
    text: "Click to access downlaod free RRB mock tests.",
    features: [
      { icon: 'icon-coupon', text: 'Free mock tests' },
      { icon: 'icon-notification', text: 'Notifications updates for exams' },
      { icon: 'icon-document', text: 'Syllabus copies and more' }
    ]
  }
];

export const books = [
  {
    id: 8,
    title: "UPSC DRUG INSPECTOR BOOK | CDSCO SPECIAL EDITION 2026",
    link:'https://amzn.to/4oyhLVt',
    image:"../assets/global/upsc_drug_inspector.jpeg",
    text: " India's first 100% syllabus-wise UPSC Drug Inspector complete guide. - Strictly as per official syllabus to meet CDSCO requirements.",
    features: [
    ]
  },
  {
    id: 3,
    icon: "icon-graduation-1 text-64 text-green-1",
    title: "RRB Pharmacist 2025",
    image:"../assets/global/book_rrb.svg",
    link:'https://amzn.to/3DePH7T',
    text: "The first comprehensive PAN-India book for RRB, covering 100% of the syllabus.",
    features: [
    ]
  },
  {
    id: 7,
    title: "GVK Drug Inspector One Book",
    link:'https://amzn.to/4os7URU',
    image:"../assets/global/drug_inspector_one_book.png",
    text: "TSPSC/APPSC GVK DRUG INSPECTOR ONE BOOK.",
    vendor: "Flipkart",
    features: [
    ]
  },
 
  {
    id: 2,
    title: "Pharmacist Grade 2",
    link:'https://amzn.to/3ETj00c',
    image:"../assets/global/book_pharmacist_grade_2.svg",
    text: "All in One Book for Drug inspector, Govt Analyst, ESIC Pharmacist, Railway Pharmacist (RRB).",
    features: [
    ]
  }
  
];

export const stepsTwo = [
  {
    id: 1,
    imageSrc: "/assets/img/home-3/works/1.svg",
    text: "Browse courses from our expert contributors.",
  },
  {
    id: 2,
    imageSrc: "/assets/img/home-3/works/2.svg",
    text: "Purchase quickly and securely.",
  },
  {
    id: 3,
    imageSrc: "/assets/img/home-3/works/3.svg",
    text: "That’s it! Start learning right away.",
  },
];
